import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'
import { CButton, CRow, CTooltip } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilLoopCircular, cilPencil, cilTrash } from '@coreui/icons'

const ActionButton = ({
  item,
  hasChange,
  onEdit,
  onChange,
  onDelete,
  hasChangePass,
  onChangePass,
  ...props
}) => {
  return (
    <CRow className="clear-width flex-nowrap px-1">
      {onEdit && (
        <CTooltip content="Sửa">
          <CButton onClick={() => onEdit(item.id)} color="success" className="text-white">
            <CIcon icon={cilPencil} size="sm" />
          </CButton>
        </CTooltip>
      )}
      {hasChange && (
        <CTooltip content="Đổi trả">
          <CButton onClick={() => onChange(item.id)} color="warning" className="text-white">
            <CIcon icon={cilLoopCircular} size="sm" />
          </CButton>
        </CTooltip>
      )}
      {hasChangePass && (
        <CTooltip content="Đổi mật khẩu">
          <CButton onClick={() => onChangePass()} color="warning" className="text-white">
            <CIcon icon={cilLoopCircular} size="sm" />
            <CIcon icon={cilLockLocked} size="sm" />
          </CButton>
        </CTooltip>
      )}
      {onDelete && (
        <CTooltip content="Xoá">
          <CButton onClick={() => onDelete(item.id)} color="danger" className="text-white ml-1">
            <CIcon icon={cilTrash} size="sm" />
          </CButton>
        </CTooltip>
      )}
    </CRow>
  )
}

ActionButton.propTypes = {
  hasChange: PropTypes.bool,
  hasChangePass: PropTypes.bool,
  item: PropTypes.object,
  onDelete: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onEdit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onChangePass: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
}
export default ActionButton
